export default [

     {
          path: '/plan',
          name: 'Plan',
          component: () => import("@/views/Page/Plan/Plan.vue"),
          meta: {
               title: 'Plan',
          },
     },
     {
          path: '/plan/:planId/courses',
          name: 'PlanCourses',
          component: () => import("@/views/Page/Plan/PlanCourses.vue"),
          meta: {
               title: 'Plan Courses',
          },
     },
     {
          path: '/plan/:planId/sections',
          name: 'PlanSections',
          component: () => import("@/views/Page/Plan/PlanSections.vue"),
          meta: {
               title: 'Plan Sections',
          },
     }
];